// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Box } from "@mui/material";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";

// const ExactMenu = ({ itm, index, selectedIndex, setSelectedIndex, isMainMenu = true }) => {
//   const handleListItemClick = (event, index) => {
//     isMainMenu && setSelectedIndex(index);
//   };
//   return (
//     <Link to={itm.to}>
//       <ListItem
//         key={`${itm?.key}-${itm?.title}`}
//         disablePadding
//         sx={{ display: "block", height: `32` }}
//         onClick={event => handleListItemClick(event, index)}
//       >
//         <ListItemButton selected={isMainMenu && selectedIndex === index}>
//           <ListItemIcon sx={{ color: "white" }}>{itm?.iconClass}</ListItemIcon>
//           <ListItemText primary={itm?.title} primaryTypographyProps={{ color: "white" }} />
//         </ListItemButton>
//       </ListItem>
//     </Link>
//   );
// };
// const ExpandedMenu = ({ menuToExpand, index, selectedIndex, setSelectedIndex }) => {
//   const [openSubMenu, setOpenSubMenu] = useState(false);

//   const toggleSubMenu = () => setOpenSubMenu(!openSubMenu);

//   return (
//     <>
//       <ListItem onClick={toggleSubMenu} disablePadding>
//         <ListItemButton selected={selectedIndex === index}>
//           <ListItemIcon sx={{ color: "white" }}>{menuToExpand?.iconClass}</ListItemIcon>
//           <ListItemText primary={menuToExpand?.title} primaryTypographyProps={{ color: "white" }} />
//         </ListItemButton>
//         {openSubMenu ? <ExpandLess /> : <ExpandMore />}
//       </ListItem>
//       <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
//         <Box px={3}>
//           {menuToExpand?.detail?.map((menuitm, i) => (
//             <ExactMenu
//               key={i}
//               itm={menuitm}
//               index={index}
//               selectedIndex={selectedIndex}
//               setSelectedIndex={setSelectedIndex}
//               isMainMenu={false}
//             />
//           ))}
//         </Box>
//       </Collapse>
//     </>
//   );
// };
// export default function IPDCMenuList({ open, menuList }) {
//   const [selectedIndex, setSelectedIndex] = useState(0);

//   return (
//     <List>
//       {menuList?.map((menuItem, index) =>
//         menuItem?.key === "GROUP" ? (
//           <ExpandedMenu
//             key={index}
//             menuToExpand={menuItem}
//             index={index}
//             selectedIndex={selectedIndex}
//             setSelectedIndex={setSelectedIndex}
//           />
//         ) : (
//           <ExactMenu
//             key={index}
//             itm={menuItem}
//             index={index}
//             selectedIndex={selectedIndex}
//             setSelectedIndex={setSelectedIndex}
//             isMainMenu={true}
//           />
//         ),
//       )}
//     </List>
//   );
// }
//************************************************************************************ */
import { useState } from "react";
import { Link } from "react-router-dom";
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Box } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

// Keep the original behavior for GROUP items
const isGroupItem = (item) => item?.key === "GROUP";

// Recursive menu item renderer
const RenderMenuItem = ({ item, index, selectedIndex, setSelectedIndex, isMainMenu = true, depth = 0 }) => {
  const [open, setOpen] = useState(false);
  
  const handleClick = (event) => {
    if (isMainMenu) {
      setSelectedIndex(index);
    }
    // Check if item has detail (either from GROUP or nested menu)
    if (item.detail) {
      setOpen(!open);
    }
  };

  // If it has detail, render as expandable
  if (item.detail) {
    return (
      <>
        <ListItem 
          disablePadding 
          onClick={handleClick}
          sx={{ pl: depth * 2 }}
        >
          <ListItemButton selected={isMainMenu && selectedIndex === index}>
            <ListItemIcon sx={{ color: "white" }}>{item?.iconClass}</ListItemIcon>
            <ListItemText primary={item?.title} primaryTypographyProps={{ color: "white" }} />
            {open ? <ExpandLess sx={{ color: "white" }} /> : <ExpandMore sx={{ color: "white" }} />}
          </ListItemButton>
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box>
            {item.detail.map((subItem, subIndex) => (
              <RenderMenuItem
                key={subIndex}
                item={subItem}
                index={subIndex}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                isMainMenu={false}
                depth={depth + 1}
              />
            ))}
          </Box>
        </Collapse>
      </>
    );
  }

  // If it has 'to', render as link
  if (item.to) {
    return (
      <Link to={item.to} style={{ textDecoration: 'none', color: 'inherit' }}>
        <ListItem
          disablePadding
          sx={{ pl: depth * 2 }}
          onClick={(event) => isMainMenu && setSelectedIndex(index)}
        >
          <ListItemButton selected={isMainMenu && selectedIndex === index}>
            <ListItemIcon sx={{ color: "white" }}>{item?.iconClass}</ListItemIcon>
            <ListItemText primary={item?.title} primaryTypographyProps={{ color: "white" }} />
          </ListItemButton>
        </ListItem>
      </Link>
    );
  }

  return null;
};

export default function IPDCMenuList({ open, menuList }) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <List>
      {menuList?.map((menuItem, index) => (
        <RenderMenuItem
          key={index}
          item={menuItem}
          index={index}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          isMainMenu={true}
          depth={0}
        />
      ))}
    </List>
  );
}